//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";
import i18n from "i18n";
import { useTranslation } from 'react-i18next';

// custom pages
import Logo from "assets/img/consent-logo.png";
import { consentStyles } from "../styles";
import auth from "apis/auth/auth";
import Loader from "components/Loader/CenteredLoader";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Newsignaturelogo from 'assets/img/Henry Schein Thrive Service plus.png';
import upgardeloyalty from 'apis/UpgradeLoyalty/upgardeloyalty';
import { toast } from 'react-toastify'; 

// custom TextField
const CssTextField = withStyles({
    root: {
        "& div.Mui-focused": {
            color: "##D3D3D3",
        },
        "& .MuiFormdiv-root": {
            color: "#707070",
        },
        "& .MuiInputBase-input": {
            color: "#707070",
        },
        "& .MuiInput-underline:before": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#707070",
            },
            "&:hover fieldset": {
                borderColor: "#707070",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#707070",
            },
            "&.MuiOutlinedInput-root": {
                borderRadius: '5px !important',
            },
            marginTop: 0,
        },
    },
})(TextField);


export default function FormOne({ setNext, setStates, states }) {

    const classes = consentStyles();
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();
    const param = new URLSearchParams(location.search);
    const token = param.get("token");

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [data, setData] = useState({ db: 'US' });
    const { getShiptoDetail } = upgardeloyalty();

    // const [states, setstates] = useState({
    //     practiceOwnerfirstName: '',
    //     practiceOwnerlastName: '',
    //     pointOfContactfirstName: '',
    //     pointOfContactlastName: '',
    //     practiceName: '',
    //     henryaccountNumber: '',
    //     title: '',

    //     practiceOwnerfirstNameError: false,
    //     practiceOwnerlastNameError: false,
    //     pointOfContactfirstNameError: false,
    //     pointOfContactlastNameError: false,
    //     practiceNameError: false,
    //     henryaccountNumberError: false,
    //     titleError: false,

    // });

    // const handleSearch = async () => {
    //     try {
    //       const values = {
    //         shipto: states?.henryaccountNumber,
    //         country: "US",
    //       };
      
    //       const res = await getShiptoDetail(values);
      
    //       if (res.result_status == 1) {
    //         const flag = res?.data?.service_plus_flag; 
    //         const statusname = res?.data?.service_plus_status;
    //         setStatus(flag);
    //         setMessage(statusname)
      
    //         // ✅ check using flag instead of status
    //         if (flag === false || flag === null) {
    //           setNext("2");
    //         }
    //       }
    //       if (res.result_status == 0) {
           
           

      
    //         // ✅ check using flag instead of status
    //         if (res.message === "Account number not found. Please verify and try again") {
    //           setNext("2");
    //         }
    //       }
    //     } catch (err) {
    //       console.error(err);
    //     }
    //   };
      


    

    const handlesubmit = async () => {

        try {
            let error = false
            if (states?.practiceOwnerfirstName == '') {
                setStates({
                    practiceOwnerfirstNameError: true
                })
                error = true

            }
            if (states?.practiceOwnerlastName == '') {
                setStates({
                    practiceOwnerlastNameError: true
                })
                error = true

            }
            if (states?.pointOfContactfirstName == '') {
                setStates({
                    pointOfContactfirstNameError: true
                })
                error = true
            }

            if (states?.pointOfContactlastName == '') {
                setStates({
                    pointOfContactlastNameError: true
                })
                error = true
            }
            if (states?.practiceName == '') {
                setStates({
                    practiceNameError: true
                })
                error = true
            }
            if (states?.henryaccountNumber == '') {
                setStates({
                    henryaccountNumberError: true
                })
                error = true
            }
            if (states?.title == '') {
                setStates({
                    titleerror: true
                })

            }

            if (error) {
                return false
            } else {
                setStates({
                    practiceOwnerfirstNameError: false,
                    practiceOwnerlastNameError: false,
                    pointOfContactfirstNameError: false,
                    pointOfContactlastNameError: false,
                    practiceNameError: false,
                    henryaccountNumberError: false,
                    titleerror: false,
                })
                setNext('2');
            }
        }
        catch (e) {
            console.log({ e });
        }
    }

    return (
        <div style={{ width: "100%", margin: 'auto', background: '#fff', height: '100vh' }}>
             <img style={{ width: "100%" }} src={Newsignaturelogo}></img>
            <Grid container alignItems="flex-start" spacing={2} className={classes.formtxtTop}>
                <React.Fragment>
                    <Grid container spacing={2} className={classes.formtxt1}>
                        <Grid item xs={12} lg={3}></Grid>
                        <Grid item xs={12} lg={3} className={states?.henryaccountNumberError ? classes.formError1 : classes.formtxt}>
                            <label className={classes.labelTxt}>
                                Henry Schein Account Number: </label>
                            <CssTextField
                                // error={states?.henryaccountNumberError}
                                type="text"
                                autoComplete="off"
                                variant="outlined"
                                onChange={(e) => {
                                    const regex = /^[0-9\s\-]*$/
                                    if (regex.test(e?.target?.value)) {
                                    setStates({
                                        henryaccountNumber: e?.target?.value,
                                        henryaccountNumberError:false
                                    })
                                }
                                }
                                }
                                error={states?.henryaccountNumberError}
                                value={states.henryaccountNumber}
                                className={classes.textField}
                            />
                            {/* {states?.henryaccountNumberError || status === true ? (
                                <div className={classes.errorTxt}>
                                    
                                    <p>
                                        {status === true && message === "Inprogress"
                                            ? "Serviceplus Enrollment for this ShipTo inprogress.."
                                            : status === true
                                            ? "You are already enrolled in Thrive Service plus."
                                            : "This field is required."}
                                    </p>
                                </div>
                            ) : null} */}
                            {states?.henryaccountNumberError && <div className={classes.errorTxt}><InfoOutlinedIcon
                                className={classes.emailInputIcon}
                            /><p>This field is required.</p></div>}
                        </Grid>
                        <Grid item xs={12} lg={3} className={states?.titleerror ? classes.formError1 : classes.formtxt}>
                            <div style={{
                                color: '#060606',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 500,
                                fontSize: '.95em',
                                marginBottom: 10
                            }}   >Title</div>
                            <CssTextField
                                select
                                autoComplete="off"
                                variant="outlined"
                                label="Please Select"
                                value={states.title} // Ensure it's controlled
                                onChange={(e) => {
                                    setStates({

                                        title: e.target.value,
                                        titleerror: false
                                    });
                                }}
                            >
                                <MenuItem value="">Please Select</MenuItem>
                                <MenuItem value="Dentist">Dentist</MenuItem>
                                <MenuItem value="Office Manager">Office Manager</MenuItem>
                                <MenuItem value="Dental Hygienist">Dental Hygienist</MenuItem>
                                <MenuItem value="Dental Assistant">Dental Assistant</MenuItem>
                                <MenuItem value="Billing Coordinator">Billing Coordinator</MenuItem>
                                <MenuItem></MenuItem>
                            </CssTextField>
                            {states?.titleerror && <div className={classes.errorTxt}><InfoOutlinedIcon
                                className={classes.emailInputIcon}
                            /><p>This field is required.</p></div>}
                        </Grid>
                        <Grid item xs={12} lg={3}></Grid>
                    </Grid>

                    <Grid container spacing={2} className={classes.formtxt1}>
                        <Grid item xs={12} lg={3}></Grid>
                        <Grid item xs={12} lg={3} className={states?.practiceNameError ? classes.formError : classes.formtxt}>
                            <label className={classes.labelTxt}>
                                Practice Name <span style={{ color: 'red' }}>*</span></label>
                            <CssTextField
                                // error={states?.practiceNameError}
                                type="text"
                                autoComplete="off"
                                variant="outlined"
                                onChange={(e) => {
                                    const regex = /^[a-zA-Z]*$/;
                                    if (regex.test(e?.target?.value)) {
                                    setStates({
                                        practiceName: e?.target?.value,
                                        practiceNameError:false
                                    })
                                }
                                }}
                                error={states?.practiceNameError}
                                value={states.practiceName}
                                className={classes.textField}
                            />
                            {states?.practiceNameError && <div className={classes.errorTxt}><InfoOutlinedIcon
                                className={classes.emailInputIcon}
                            /><p>This field is required.</p></div>}
                        </Grid>
                        <Grid item xs={12} lg={6}></Grid>
                    </Grid>
                    <Grid container spacing={2} className={classes.formtxt1}>
                        <Grid item xs={12} lg={3}></Grid>
                        <Grid item xs={12} lg={3} className={states?.practiceOwnerfirstNameError ? classes.formError : classes.formtxt}>
                            <label className={classes.labelTxt}>
                                Practice Owner Name <span style={{ color: 'red' }}>*</span></label>
                            <CssTextField
                                // error={states?.practiceOwnerfirstNameError}
                                type="text"
                                autoComplete="off"
                                variant="outlined"
                                onChange={(e) => {
                                    const regex = /^[a-zA-Z]*$/;
                                    if (regex.test(e?.target?.value)) {
                                    setStates({
                                        practiceOwnerfirstName: e?.target?.value,
                                        practiceOwnerName: `${e?.target?.value} ${states?.practiceOwnerlastName}`,
                                        practiceOwnerfirstNameError:false
                                    })
                                }
                                }}
                                error={states?. practiceOwnerfirstNameError}
                                value={states.practiceOwnerfirstName}
                                className={classes.textField}
                            />
                            <label style={{
                                color: '#57647E',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 500,
                                fontSize: '.75em',
                                marginTop: 5
                            }}> First Name</label>
                            {states?.practiceOwnerfirstNameError && <div className={classes.errorTxt}><InfoOutlinedIcon
                                className={classes.emailInputIcon}
                            /><p>This field is required.</p></div>}
                        </Grid>
                        <Grid item xs={12} lg={3} className={states?.practiceOwnerfirstNameError ? classes.formError2 : classes.formtxt}>
                            <label style={{ marginTop: '27px' }}>
                                <span></span>
                            </label>
                            <CssTextField
                                // error={states?.practiceOwnerfirstNameError}
                                type="text"
                                autoComplete="off"
                                variant="outlined"
                                onChange={(e) => {
                                    const regex = /^[a-zA-Z]*$/;
                                    if (regex.test(e?.target?.value)) {
                                    setStates({
                                        practiceOwnerlastName: e?.target?.value,
                                        practiceOwnerName: `${states?.practiceOwnerfirstName} ${e?.target?.value}`,
                                        practiceOwnerlastNameError:false
                                    })
                                }
                                }}
                                error={states?.practiceOwnerlastNameError}
                                value={states.practiceOwnerlastName}
                                className={classes.textField}
                            />
                            <label style={{
                                color: '#57647E',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 500,
                                fontSize: '.75em',
                                marginTop: 5
                            }}>Last Name</label>
                        </Grid>
                        <Grid item xs={12} lg={3}></Grid>
                    </Grid>
                    <Grid container spacing={2} className={classes.formtxt1}>
                        <Grid item xs={12} lg={3}></Grid>
                        <Grid item xs={12} lg={3} className={states?.pointOfContactfirstNameError ? classes.formError : classes.formtxt}>
                            <label className={classes.labelTxt}>
                                Point of Contact Name <span style={{ color: 'red' }}>*</span></label>
                            <CssTextField
                                // error={states?.pointOfContactfirstNameError}
                                type="text"
                                autoComplete="off"
                                variant="outlined"
                                onChange={(e) => {
                                    const regex = /^[a-zA-Z]*$/;
                                    if (regex.test(e?.target?.value)) {
                                    setStates({
                                        pointOfContactfirstName: e?.target?.value,
                                        pointOfContact: `${e.target.value} ${states.pointOfContactlastName}`,
                                        pointOfContactfirstNameError:false
                                    })
                                }
                                }}
                                error={states?. pointOfContactfirstNameError}
                                value={states.pointOfContactfirstName}
                                className={classes.textField}
                            />
                            <label style={{
                                color: '#57647E',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 500,
                                fontSize: '.75em',
                                marginTop: 5
                            }}> First Name</label>
                            {states?.pointOfContactfirstNameError && <div className={classes.errorTxt}><InfoOutlinedIcon
                                className={classes.emailInputIcon}
                            /><p>This field is required.</p></div>}
                        </Grid>
                        <Grid item xs={12} lg={3} className={states?.pointOfContactfirstNameError ? classes.formError2 : classes.formtxt}>
                            <label style={{ marginTop: '27px' }}>
                                <span></span>
                            </label>
                            <CssTextField
                                // error={states?.pointOfContactlastNameError}
                                type="text"
                                autoComplete="off"
                                variant="outlined"
                                onChange={(e) => {
                                    const regex = /^[a-zA-Z]*$/;
                                    if (regex.test(e?.target?.value)) {
                                    setStates({
                                        pointOfContactlastName: e?.target?.value,
                                        pointOfContact: `${states.pointOfContactfirstName} ${e.target.value} `,
                                        pointOfContactlastNameError:false
                                    })
                                }
                                }}
                                error={states?.pointOfContactlastNameError}
                                value={states.pointOfContactlastName}
                                className={classes.textField}
                            />
                            <label style={{
                                color: '#57647E',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 500,
                                fontSize: '.75em',
                                marginTop: 5
                            }}>Last Name</label>
                        </Grid>
                        <Grid item xs={12} lg={3}></Grid>
                    </Grid>
                    <Grid container spacing={2} className={classes.formtxt1}>
                        <div style={{
                            border: '1px solid transparent',
                            borderTopColor: '#ededf1',
                            width: '50%',
                            margin: 'auto',
                            marginTop: 20,
                            paddingTop: 25
                        }}>
                            <button style={{
                                float: 'right',
                                border: '1px solid transparent',
                                minWidth: '128px',
                                height: '3em',
                                color: '#fff',
                                borderRadius: 4,
                                background: '#2e69ff',
                                cursor: 'pointer'

                            }}  
                            // onClick={async () => {
                            //     const result = await handlesubmit(); // waits for validation
                            //     if (result !== false) {
                            //       await handleSearch(); // calls API if valid
                            //     }
                            //   }}
                            onClick={handlesubmit}
                              >Next</button>
                        </div>
                    </Grid>
                </React.Fragment>
            </Grid>
        </div>
    );
}